import { render, staticRenderFns } from "./ContratoModeloSocinal.vue?vue&type=template&id=738a45b1&scoped=true&"
import script from "./ContratoModeloSocinal.vue?vue&type=script&lang=js&"
export * from "./ContratoModeloSocinal.vue?vue&type=script&lang=js&"
import style0 from "./ContratoModeloSocinal.vue?vue&type=style&index=0&id=738a45b1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "738a45b1",
  null
  
)

export default component.exports